export type TypographyLevels = 'h1' | 'h2' | 'h3' | 'h4' | 'h5';

export enum ComponentTypes {
  Title = 'Title',
  Paragraph = 'Paragraph',
  Link = 'Link',
}
